localStorage.removeItem("token");
localStorage.removeItem("apollo-cache-persist");
sessionStorage.removeItem("positions");
sessionStorage.removeItem("ignoreScrollBehavior");

if (localStorage.getItem("lang") === "no") {
  localStorage.setItem("lang", "nb-NO");
}

if (localStorage.getItem("lang")) {
  document.documentElement.setAttribute(
    "lang",
    localStorage.getItem("lang").split("-")[0]
  );
}

if (process.env.VUE_APP_BANNERS_USE_ADNUNTIUS === "true") {
  if (!window.adn) window.adn = { calls: [] };
  const script = document.createElement("script");
  script.setAttribute("type", "text/javascript");
  script.src = "https://cdn.adnuntius.com/adn.js";
  script.async = true;
  document.head.append(script);
}

if (process.env.VUE_APP_BANNERS_USE_NIF === "true") {
  if (!window.adn) window.adn = { calls: [] };
  const script = document.createElement("script");
  script.setAttribute("type", "text/javascript");
  script.src = "https://tags.adnuntius.com/custom/nifRequest.js";
  script.async = true;
  document.head.append(script);
}

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue, { provide } from "vue";
Vue.config.productionTip = false;

// Federation hardcoded configurations
import FederationConfig from "./plugins/federationConfig";

import "./plugins/newrelic";
import "./plugins/polyfills.js";

import "./plugins/googleTag";
import "./plugins/sentry";

import dayjs from "./plugins/dayjs";

import auth from "./utils/auth";
import sentryErrorHandler from "@/utils/sentryErrorHandler";

import allowedMutaions from "./utils/allowedMutation";
import mutationLoading from "@/utils/mutation_loading";

Object.defineProperties(Vue.prototype, {
  $auth: {
    get: () => auth
  },
  $mutateLoading: {
    // Showing loading and disabling during mutation
    get: () => mutationLoading
  },
  $federation: {
    get: () => FederationConfig
  },
  $sentryThrowError: {
    get: () => ({
      throwError: sentryErrorHandler
    })
  },
  $dayjs: { get: () => dayjs },
  $allowedMutation: {
    get: () => allowedMutaions
  }
});

import "@/css/index.scss";
import "@/css/print_media.scss";
import "flag-icons/css/flag-icons.min.css";
import "@/css/entsys-icons/entsys-icons.css";
import router from "./plugins/router";
import Root from "./Root.vue";
import gql from "fraql";
import * as Sentry from "@sentry/vue";
import { DefaultApolloClient } from "@vue/apollo-composable";
import { apolloClient, apolloProvider } from "./plugins/apollo/index.js";
import i18next, { loadUpTranslations } from "./plugins/i18next/i18next.js";
import { initHelpscoutBeacon } from "@/plugins/beacon.js";
import initGoogleMaps from "./plugins/googleMaps.js";

init();
async function init() {
  // capture authToken from the url and log in automatically
  if (location.href.includes("auth/signinwin/nif")) {
    window.location.replace(
      process.env.VUE_APP_API_URL +
        "/integrations/nif/callback" +
        window.location.search
    );
    return; // Do not continue from this point on
  } else if (!auth.isAuthenticated) {
    auth.removeToken();
  }

  const params1 = new URLSearchParams(location.search);
  document.querySelector("#infoLoading").style.display = "inline";

  await loadUpTranslations()
    .then(() => {
      switch (i18next.language) {
        case "nb-NO":
          dayjs.locale("nb"); // dayjs does not have nb-NO
          break;
        default:
          dayjs.locale(i18next.language);
      }
      document.documentElement.setAttribute(
        "lang",
        i18next.language.split("-")[0]
      );
      initGoogleMaps();
      initHelpscoutBeacon(i18next.language);
    })
    .catch(err => {
      if (err) {
        console.error("Something went wrong loading translations", err);
      }
    });

  if (params1.has("auth_token")) {
    /*this.loadingText = this.$t(
      "common:authentication.authTokenText",
      "Signing in..."
    );*/
    try {
      const { data } = await apolloClient.mutate({
        mutation: gql`
          mutation personSignIn($authToken: String) {
            personSignIn(input: { authToken: $authToken }) {
              signInPayload {
                token
                person {
                  id
                }
              }
              status
            }
          }
        `,
        fetchPolicy: "no-cache",
        variables: {
          authToken: params1.get("auth_token")
        }
      });

      if (data?.personSignIn?.signInPayload?.token) {
        const token = data.personSignIn.signInPayload.token;
        auth.setSession(token);
        //history.replaceState(window.state, "", location.href.split("?")[0]);
      } else {
        Sentry.withScope(scope => {
          scope.setTag("auth_token_login");
          scope.setLevel("info");
          Sentry.captureMessage("personSignInPayload did not return token");
        });
        sessionStorage.setItem("authTokenUrlExpired", "true"); // used in App.vue

        if (window.location.href === "/") {
          window.location.reload();
        } else window.location.href = "/";

        return;
      }
    } catch (error) {
      console.error(error);
      Sentry.captureException(error);
    }
  }

  new Vue({
    router,
    apolloProvider,
    setup() {
      document.querySelector("#infoLoading").style.display = "none";
      provide("embeddedMode", params1.has("embeddedMode"));
      provide(DefaultApolloClient, apolloClient);
      provide("appAuth", auth);
      provide("appFederation", FederationConfig);
    },
    render(h) {
      return h(Root, {});
    }
  }).$mount("#app");
}
